


















import { defineComponent } from '@nuxtjs/composition-api'
import NewButton from '@/components/Inputs/new-design/NewButton.vue'

export default defineComponent({
  name: 'BlockFormError',
  components: { NewButton },
  props: {
    description: {
      type: String,
      default: '',
    },
  },
  setup(_, { emit }) {
    const handleClick = () => {
      emit('click')
    }

    return {
      handleClick,
    }
  },
})
